var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useFirstRunState, useSecondRunState, } from '@office-start/first-run-state-service';
import { RunType } from '@office-start/first-run-types';
import { LazyFeature } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
var FirstRunComponentLazy = lazy(function () {
    return import(
    /*webpackChunkName: "first-run-component" */ '@office-start/first-run-component');
});
var determineRunType = function (secondRunEnabled, firstRunCompleted, secondRunCompleted) {
    if (!firstRunCompleted) {
        return RunType.FirstRun;
    }
    else if (firstRunCompleted && secondRunEnabled && !secondRunCompleted) {
        return RunType.SecondRun;
    }
    else {
        return RunType.Disabled;
    }
};
export var FirstRun = function () {
    var _a, _b;
    var featureGates = useFeatureGates().data;
    var firstRunState = useFirstRunState().data;
    var secondRunState = useSecondRunState().data;
    var secondRunEnabled = ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.secondRunGates) === null || _b === void 0 ? void 0 : _b.secondRunSREConsumerEnabled) ||
        false;
    var _c = __read(React.useState(RunType.Disabled), 2), runType = _c[0], setRunType = _c[1];
    React.useEffect(function () {
        // This determines what version of the FRE we should serve
        // We must first wait for both state objects to be populated
        // and that RunType == Disabled. We do not want to calculate this again
        // if RunType is already set to something other than Disabled
        // because we do not want to rerender the FirstRunComponent
        // which would trigger another state update.
        if (firstRunState && secondRunState && runType === RunType.Disabled) {
            var newRunType = determineRunType(secondRunEnabled, firstRunState.CompletedFirstRun, secondRunState.CompletedFirstRun);
            setRunType(newRunType);
        }
    }, [firstRunState, secondRunState, secondRunEnabled, runType]);
    return (React.createElement(LazyFeature, { disabled: runType == RunType.Disabled },
        React.createElement(FirstRunComponentLazy, { runType: runType })));
};
//# sourceMappingURL=FirstRun.js.map